import * as THREE from 'three';
import p5 from "p5";
import { QTreeRect } from './QTreeRect';


export class DrawerBase {

    public rects:QTreeRect[];
    public count:number=0;

    show(){
        
        //this.count=0;

    }

    hide(){

        //

    }

    reset(): void {
        this.count=0;
    }

    update(){



    }

}